import "./App.css";
import Sambutanvid from "./Component/Sambutan";
import NavComplete from "./Component/Navbar1";
import CarSection from "./Component/Hsection1";
import Footer from "./Component/footer";
import CardSection from "./Component/Hsection2";
import Whyus from "./Component/Whyus";

function App() {
  return (
    <div className="App">
      <NavComplete />
      <Sambutanvid />
      <CarSection />
      <CardSection />
      <Whyus />
      <Footer />
    </div>
  );
}

export default App;
